import z from "zod";

export const locationModalDataSchema = z.object({});

export type LocationModalDataProps = z.infer<typeof locationModalDataSchema>;
